import {QuizSession, mapQuizSessionDbToType} from '@cp/model';
import {getDoc} from 'firebase/firestore';
import {getQuizSessionDocRef} from './getQuizSessionDocRef';

export default async function getQuizSessionDoc(uid: string, sessionId: string): Promise<QuizSession | undefined> {
  const ref = getQuizSessionDocRef(uid, sessionId);
  const snapshot = await getDoc(ref);
  return mapQuizSessionDbToType(snapshot);
}
